import { Divider } from "../design/divider";
import { Heading, Subheading } from "../design/heading";

export function Stat({ title, value }: { title: string; value: string }) {
  return (
    <div>
      <Divider />
      <Subheading className="mt-6 font-medium text-lg/6 sm:text-sm/6">{title}</Subheading>
      <Heading className="mt-3 font-semibold text-3xl/8 sm:text-2xl/8">{value}</Heading>
    </div>
  );
}
